import { default as Box } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Text } from 'components/Text';

export const MenuLinkWrapper = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid #eee',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '5rem',
  paddingLeft: 20,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 32
  },
  cursor: 'pointer',
  backgroundColor: theme.palette.background.default
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  padding: '1rem',
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    paddingLeft: '1.75rem',
    paddingRight: '1.75rem'
  }
}));

export const MenuLinkTitle = styled(Text)(() => ({
  fontWeight: 'bold',
  fontSize: '1rem',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}));
